import axios from "axios";
import { API_BASEURL } from "../utils/baseURL";
import { authHeader } from "../utils/headers";

export const getRolePermissions = async () => {
  return await axios
    .get(`${API_BASEURL}v1/role/permissions`, {
      headers: authHeader(),
    })
    .catch((error) => {
      return error;
    });
};
